export async function edgeFailureMessage(error,fallback){
 try{const value=await error?.context?.json();if(typeof value?.error==='string')return value.error;}catch{}
 return fallback;
}
export async function createRemoteProposal(client,job,company){
 const to=String(job.propOwner?.email||'').trim();
 if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(to))throw Error('Add a valid property owner email in Job Info first.');
 if(!crypto.randomUUID)throw Error('Open the secure HTTPS site to create a signing link.');
 const token=crypto.randomUUID();
 const {error}=await client.from('signature_requests').insert({token,job_id:String(job.id),sent_to:to,company:company||{}});
 if(error)throw Error(error.code==='42501'?'Only an active office account can create a signing request.':'Could not create the signing request. Save the job and retry, or contact the office.');
 return {token,status:'pending',sentTo:to,createdAt:new Date().toISOString(),emailSent:false};
}
export async function emailRemoteProposal(client,token){
 const {data,error}=await client.functions.invoke('sign-proposal',{body:{action:'send',token}});
 if(error)throw Error(await edgeFailureMessage(error,'Email delivery failed. Copy the signing link and send it manually.'));
 if(!data?.ok)throw Error(data?.error||'Email delivery failed. Copy the signing link and send it manually.');
}
